<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="vote-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="title t-vote"></div>

                    <ul class="vote-list">
                        <li class="u-btn" v-for="n in 8" :key="n" :class="{'act' : active == n}" @click="active = n;vote = n;">
                            <div class="pic" :class="'char-' + n"></div>
                        </li>
                    </ul>

                    <div class="u-btn submit" @click="call_submit" v-if="this.uflag == 10 || this.uflag == 0"></div>
                    <div class="u-btn submit disabled" v-else></div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    data : function () {
        return {
            visible : false,
            vote : 0,
            active : 0,
            uflag : 0,
        }
    },
    created (){
        //this.render();
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        call_submit (){

            if( !this.active ) return this.$toast('您尚未选择人物');

            this.destroyElement();
            this.$submit_modal({code : this.active,uflag : this.uflag})
        },
    }    
}
</script>

<style scoped>
.vote-modal{
    width: 734px;
    height: 516px;
    background-image: url(~@/assets/images/pc/vote/bg-modal.png);
}

.u-btn.close{
    top: 25px;
    right: 40px;
    width: 32px;
    height: 34px;
    background-image: url(~@/assets/images/pc/vote/btn-close.png);
}

.t-vote{
    width: 626px;
    height: 80px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/vote/title.png);
}

.vote-list{
    display: flex;
    flex-wrap: wrap;
    padding-left: 95px;
    padding-right: 70px;
    margin-top: 30px;
}

.vote-list li{
    margin: 0 15px 35px 15px;
}

.vote-list li:nth-child(2n){
    margin-top: -15px;
}

.vote-list li:nth-child(5){
    margin-left: 60px;
}

.vote-list .pic{
    width: 91px;
    height: 91px;
    background-repeat: no-repeat;
}

.vote-list .pic.char-1{
   background-image: url(~@/assets/images/pc/vote/select/1.png); 
}

.vote-list .act .pic.char-1{
   background-image: url(~@/assets/images/pc/vote/select/act/1.png); 
}

.vote-list .pic.char-2{
   background-image: url(~@/assets/images/pc/vote/select/2.png); 
}

.vote-list .act .pic.char-2{
   background-image: url(~@/assets/images/pc/vote/select/act/2.png); 
}

.vote-list .pic.char-3{
   background-image: url(~@/assets/images/pc/vote/select/3.png); 
}

.vote-list .act .pic.char-3{
   background-image: url(~@/assets/images/pc/vote/select/act/3.png); 
}

.vote-list .pic.char-4{
   background-image: url(~@/assets/images/pc/vote/select/4.png); 
}

.vote-list .act .pic.char-4{
   background-image: url(~@/assets/images/pc/vote/select/act/4.png); 
}

.vote-list .pic.char-5{
   background-image: url(~@/assets/images/pc/vote/select/5.png); 
}

.vote-list .act .pic.char-5{
   background-image: url(~@/assets/images/pc/vote/select/act/5.png); 
}

.vote-list .pic.char-6{
   background-image: url(~@/assets/images/pc/vote/select/6.png); 
}

.vote-list .act .pic.char-6{
   background-image: url(~@/assets/images/pc/vote/select/act/6.png); 
}

.vote-list .pic.char-7{
   background-image: url(~@/assets/images/pc/vote/select/7.png); 
}

.vote-list .act .pic.char-7{
   background-image: url(~@/assets/images/pc/vote/select/act/7.png); 
}

.vote-list .pic.char-8{
   background-image: url(~@/assets/images/pc/vote/select/8.png); 
}

.vote-list .act .pic.char-8{
   background-image: url(~@/assets/images/pc/vote/select/act/8.png); 
}

.u-btn.submit{
    width: 214px;
    height: 51px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/vote/btn-submit.png); 
}
</style>


// WEBPACK FOOTER //
// src/components/VoteModal/voteModal.vue